import { SyntheticEvent } from 'react';

export const showMiddleVideoFrame = ({
  currentTarget: video,
}: SyntheticEvent<HTMLVideoElement>) => {
  if (Number.isFinite(video.duration)) {
    video.currentTime = video.duration / 2;
  }
};
